import BuildTheme from './Theme';

const MuiTheme = BuildTheme();

export default MuiTheme;
export { BuildTheme };
